<template>
    <section>
        <vue-headful
            title="TZ Design Box - Upload Price"
            description="TZ Design Box"
        />

        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'catalog-i18n'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <tr-title-bar
                    :translatedTrUnits="translatedTrUnits"
                    :totalTrUnits="totalTrUnits"
                >
                    Category <tr-text v-bind="category.props.label"
                                :tracker="tracker"
                                @edit-tr="editTranslation"
                            > </tr-text> Translation
                </tr-title-bar>
                <nav class="breadcrumb" aria-label="breadcrumbs" v-if="catalog">
                    <ul>
                        <li><router-link :to="{name: 'catalog', params:{id:catalog.id}}">
                            {{ catalog.props.label.val }}
                        </router-link></li>
                        <li v-for="(cat, idx) in path" :key="idx">
                            <router-link :to="'/catalog/' + cat.url">
                                <tr-display v-bind="cat.props.label"></tr-display>
                            </router-link>
                        </li>
                    </ul>
                </nav>

            <div class="columns is-multiline">
                <component :is="child.tag" v-for="(child, idx) in category.children" :key="idx"
                    v-bind="child"
                    :index="idx"
                    :tracker="tracker"
                    @edit-tr="editTranslation"
                    @select="selectItem"
                ></component>
            </div>
            <tr-edit
                :trackerIdx="currentTrackerIdx"
                :tid="currentTid"
                :translatedTrUnits="translatedTrUnits"
                :totalTrUnits="totalTrUnits"
                @move-tr="selectTr($event)"
                @close="closeTrEdit"
            />
            </div>
        </div>
    </section>
</template>

<script>
import TranslationBaseView  from "@/views/TranslationBaseView"
import TrDisplay            from "@/components/translation/TrDisplay"

export default {
    name: "CategoryView",
    components: {TrDisplay},
    extends: TranslationBaseView,
    data () {
        return {
            catalog: null,
            path: [],
            category: {
                props: {label: {val: ""}},
                children: []
            },
            currentTrackerIdx: null,
            currentTid: null,
            tracker:    []
        }
    },
    methods : {
        _clearRoot () {
            this.category = { props: {label: {val: ""}}, children: []}
        },
        _updateRoot({id, path}) {
            this.catalog  = this.catalogs.find(c => c.id == id)
            this.path     = []
            const parts   = path.split ("/")
            let   cat     = this.catalog
            parts.forEach (p => {
                cat = cat.children.find (c => c.props.name.val == p)
                this.path.push (cat)
            })
            this.category = cat
        },
        selectItem(idx) {
            let obj = this.category.children [idx]
            if (obj.tag == "tr-category")
                this.$router.push ("/catalog/" + obj.url)
            else
                this.$router.push ("/article/" + obj.url)
        }
    },
    watch: {
        catalogs () {
            this.updateRoot (this.$route.params)
        }
    },
    mounted () {
        const params = this.$route.params
        if (! this.catalogs.find(c => c.id == params.id)) {
            console.log ("Load Catalog Info")
            this.$store.dispatch ("translation/loadCatalogs", {self: this})
        } else {
            this.updateRoot (params)
        }
    }
}
</script>

<style>

</style>